import React from "react";
import { View, StyleSheet } from "react-native";
import { ShimmerBox } from "../../../components/skeletons";

const QuickActionButtonSkeleton: React.FC = () => (
  <View style={styles.quickAction}>
    <ShimmerBox width={36} height={36} borderRadius={16} />
    <ShimmerBox width={90} height={12} borderRadius={6} />
  </View>
);

const styles = StyleSheet.create({
  quickAction: {
    width: "24%",
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: "rgba(255,255,255,0.6)",
    borderRadius: 32,
    borderWidth: 1,
    borderColor: "#EAECF099",
  },
});

export default QuickActionButtonSkeleton;
